module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/school/school-datatable/school-datatable.component.css
// module id = ./src/app/components/school/school-datatable/school-datatable.component.css
// module chunks = main